import React from 'react'
import ComboboxInput from '../components/Reusable/Form/ComboboxInput'
import APIS from '../constant/EndPoint'
import Button from '../components/Reusable/Button'
import { setupBranchValidationForm } from '../utils/validationSchema'
import { yupResolver } from '@hookform/resolvers/yup/dist/yup'
import { useForm } from 'react-hook-form'
import usePostHook from '../customHooks/usePostHook'
import useGetHook from '../customHooks/useGetHook'
import { queryClient } from '../root.component'

const SetupBranch = (props: any) => {

  const { refetch: refetchDefaultBranch } = useGetHook({
    queryKey: [`default-branch`],
    url: `${APIS.DEFAULT_BRANCH}`,
    params: {},
  });
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    setError,
    getValues,
    clearErrors
  } = useForm<any>({
    resolver: yupResolver(setupBranchValidationForm),
    defaultValues: async () => {
      let { data }:any = await refetchDefaultBranch()
      return {
        branch:{
          ...data
        }
      }
    }
  });


  const { mutateAsync } = usePostHook({
    queryKey: ["ddfault-branch"],
  });

  const handleUpdate = async (values: any) => {
    const url = `${APIS.BRANCH}${values?.branch}/update-default-branch/`;
    let formData = {};
    try {
      await mutateAsync({ url, formData, setError });
      queryClient.refetchQueries()
      props?.setOpenModal(false)
    } catch (err) {
      console.log(err);
    }
  }

  return (
    <div>
      <ComboboxInput
        label={""}
        placeholder={"Select Branch"}
        url={APIS.BRANCH}
        queryKey={"branch"}
        register={register("branch")}
        errors={errors?.branch}
        name={"branch"}
        getValues={getValues}
        setValue={setValue}
        clearErrors={clearErrors}
      />
      <div className="flex justify-end w-full">
        <div className="w-[100px] mr-4">
          <Button
            label={"Submit"}
            onClick={handleSubmit((data: any) =>
              handleUpdate(data)
            )}
          />
        </div>
      </div>
    </div>
  )
}

export default SetupBranch
